import React from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard'

const CopyToClipboardUI = ({className, text, onCopyToClipboard, copyToClipboardText}) =>
  <div className={className}>
    <span className='g_muted'>{text}</span>
    <span onClick={e => e.stopPropagation()}>
      <CopyToClipboard text={text}
        onCopy={onCopyToClipboard}>
        <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
      </CopyToClipboard>
      {
        copyToClipboardText === text &&
        <span className='g_m_left_50 g_muted'>copied</span>
      }
    </span>
  </div>

export default CopyToClipboardUI
